import { render, staticRenderFns } from "./IREmbed.vue?vue&type=template&id=1f2ccbc8"
import script from "./IREmbed.vue?vue&type=script&lang=js"
export * from "./IREmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports